import Button from "../Button";

import ListItem from "../ListItem";
import {useState} from "react";
import {Reoverlay} from "reoverlay";
import PolicyModal from "../modals/PolicyModal";
const  CreatePaymentCard=({handleCreateProcess,processInfo})=>{
    const price=JSON.parse(localStorage.getItem('payment_detail')||null);
    const paymentInfo=processInfo.payment.info;
    const [acceptPolicy, setAcceptPolicy] = useState(false);
    const handleAcceptPolicy = (e) => {

        setAcceptPolicy(e.target.checked)
    }
    const handlePolicyModal = () => {
        Reoverlay.showModal(PolicyModal)
    }


    return    <div className="bg-white flex flex-col mt-20 items-center justify-center p-5 rounded-lg">
        <div className="w-full mb-3 p-3 rounded-lg  border-b  flex justify-center items-center w-full flex-col">
            <h1 className="text-xl mb-2 text-green-500 font-bold ">پرداخت</h1>
            <p className=" text-sm border-gray-200">برای ادامه ابتدا باید پرداخت را انجام دهید.</p>
        </div>
        <div className="w-full justify-center items-center flex-col">
            <ListItem isPrice={true} title={'مبلغ '} value={+(paymentInfo?.init_amount)/10} priceUnit={'تومان'}/>
            <ListItem  title={'مالیات'} value={paymentInfo?.fee_percent} isPercent={true}/>
            <ListItem isPrice={true} title={'مبلغ پرداختی'} value={(paymentInfo?.total_amount)/10} priceUnit={'تومان'} isGreen={true}/>
            <div className="flex justify-between mt-2 py-2  border-t">
                <div className="flex justify-start items-center ">
                    <span className="text-xs">قوانین را می‌پذیرم</span>
                    <input className="mx-2" onChange={handleAcceptPolicy} type="checkbox" checked={acceptPolicy}/>
                </div>
                <span onClick={handlePolicyModal} className="text-blue-400 text-xs underline ">مطالعه قوانین</span>
            </div>
            <Button  rounded="rounded-lg" disabled={!acceptPolicy} theme="green" className="w-full mt-3 " onClick={handleCreateProcess}>پرداخت</Button>
        </div>
    </div>
}
export default CreatePaymentCard;